<template>
  <v-dialog
    v-model="dialog"
    scrollable
    width="500"
    :overlay="false"
    transition="dialog-transition"
  >
    <template v-slot:activator="{ on }">
      <v-btn outlined color="purple" v-on="on"
        ><v-icon class="mr-2">mdi-web</v-icon>Preview</v-btn
      >
    </template>
    <!-- <v-card class="info-card px-4" :style="cardStyle"> -->
    <v-card elevation="5" rounded class="">
      <v-card-title>
        <span
          style="font-family: 'Raleway'; font-weight: 500; color: #4caf50"
          >{{ specie.nome }}</span
        >
      </v-card-title>
      <v-card-subtitle>
        {{ specie.nome_sc }}
      </v-card-subtitle>
      <v-card-text>
        <v-row no-gutters>
          <v-img class="" max-height="250" :src="info_img_src" />
        </v-row>
        <v-row>
          <v-col>
            <span style="font-size: 18px">Info Generali</span>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col>
            <span
              style="font-size: 16px"
              v-html="formatText(all_info.info_generali)"
            ></span>
          </v-col>
        </v-row>
        <v-row>
          <v-col> </v-col>
        </v-row>
        <v-row>
          <v-col>
            <span style="font-size: 18px">Rinvaso</span>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col>
            <span
              style="font-size: 16px"
              v-html="formatText(all_info.info_rinvaso)"
            ></span>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <span style="font-size: 18px" class="">Esposizione</span>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col>
            <v-row no-gutters>
              <v-icon
                :color="specie.exposition == 1 ? 'indigo' : 'grey lighten-2'"
                >mdi-weather-cloudy</v-icon
              >
              <v-icon
                :color="specie.exposition == 2 ? 'blue' : 'grey lighten-2'"
                >mdi-weather-partly-cloudy</v-icon
              >
              <v-icon
                :color="specie.exposition == 3 ? 'orange' : 'grey lighten-2'"
                >mdi-weather-sunny</v-icon
              >
            </v-row>
            <v-row no-gutters class="mt-2">
              <span
                style="font-size: 16px"
                v-html="formatText(all_info.info_esposizione)"
              ></span>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <span style="font-size: 18px" class="">Irrigazione</span>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col>
            <v-row no-gutters>
              <v-icon
                :color="specie.water_request > 0 ? 'blue' : 'grey lighten-2'"
                >{{
                  specie.water_request > 0 ? "mdi-water" : "mdi-water-outline"
                }}</v-icon
              >
              <v-icon
                :color="specie.water_request > 1 ? 'blue' : 'grey lighten-2'"
                >{{
                  specie.water_request > 1 ? "mdi-water" : "mdi-water-outline"
                }}</v-icon
              >
              <v-icon
                :color="specie.water_request > 2 ? 'blue' : 'grey lighten-2'"
                >{{
                  specie.water_request > 2 ? "mdi-water" : "mdi-water-outline"
                }}</v-icon
              >
            </v-row>
            <v-row no-gutters class="mt-2">
              <span
                style="font-size: 16px"
                v-html="formatText(all_info.info_irrigazione)"
              ></span>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <span style="font-size: 18px" class="">Manutenzione</span>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col>
            <v-row no-gutters>
              <v-icon
                :color="specie.manutenzione > 0 ? 'red' : 'grey lighten-2'"
                >{{
                  specie.manutenzione > 0 ? "mdi-heart" : "mdi-heart-outline"
                }}</v-icon
              >
              <v-icon
                :color="specie.manutenzione > 1 ? 'red' : 'grey lighten-2'"
                >{{
                  specie.manutenzione > 1 ? "mdi-heart" : "mdi-heart-outline"
                }}</v-icon
              >
              <v-icon
                :color="specie.manutenzione > 2 ? 'red' : 'grey lighten-2'"
                >{{
                  specie.manutenzione > 2 ? "mdi-heart" : "mdi-heart-outline"
                }}</v-icon
              >
            </v-row>
            <v-row no-gutters class="mt-2">
              <span
                style="font-size: 16px"
                v-html="formatText(all_info.info_manutenzione)"
              ></span>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <span style="font-size: 18px">Malattie</span>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col>
            <span
              style="font-size: 16px"
              v-html="formatText(all_info.info_malattie)"
            ></span>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <span style="font-size: 18px">Curiosità</span>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col>
            <span
              style="font-size: 16px"
              v-html="formatText(all_info.info_curiosita)"
            ></span>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <span style="font-size: 18px">Per i più esperti</span>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col>
            <span
              style="font-size: 16px"
              v-html="formatText(all_info.info_esperti)"
            ></span>
          </v-col>
        </v-row>
        <v-row
          no-gutters
          class="my-2"
          v-for="serie in specie.series"
          :key="serie.id"
        >
          <SerieInfo :serie="serie" :id_specie="id_specie" />
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="grey" @click="dialog=false">Chiudi</v-btn>
      </v-card-actions>
    </v-card>
    <!-- </v-card> -->
  </v-dialog>
</template>

<script>
import SerieInfo from "./info_preview_serie.vue";
import formatTextMixin from "./formatTextMixin.js";
export default {
  components: {
    SerieInfo,
  },
  mixins: [formatTextMixin],
  props: {
    id_specie: String,
    all_info: Object,
  },
  data() {
    return {
      dialog: false,
    };
  },
  computed: {
    info_img_src() {
      return (
        process.env.VUE_APP_API_ROOT +
        "/specie/" +
        this.id_specie +
        "/info_img?md5=" +
        this.all_info.info_img_md5
      );
    },
    specie() {
      return this.$store.getters.get_specie_by_id(this.id_specie);
    },
  },
  methods: {},
};
</script>

<style scoped>
.info-card {
  /* Imposta un'altezza o usa l'altezza di Vuetify per vedere l'immagine */
  min-height: 800px;
}
</style>